import { Box, FlexLayout, H4, Input, Text } from '@deity/falcon-ui';
import type { EditMappingInput } from 'components/Mappings/EditMappingModal';
import type { FormikErrors, FormikTouched } from 'formik';
import type { FC } from 'react';

interface FormFieldProps {
  errors: FormikErrors<EditMappingInput>;
  touched: FormikTouched<EditMappingInput>;
  values: EditMappingInput;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, isTouched?: boolean | undefined, shouldValidate?: boolean | undefined) => void;
}

const EditMappingFormFields: FC<FormFieldProps> = ({ errors, touched, values, setFieldValue, setFieldTouched }) => {
  const requiredStar = (
    <span>
      <Text color="errorText" size="sm">
        *
      </Text>
    </span>
  );

  return (
    <Box>
      <H4 color="secondary" fontSize="lg" mb="lg">
        Please fill in a mapping name and description.
      </H4>
      <FlexLayout>
        <H4 fontWeight="bold" mb="xs">
          Mapping name
        </H4>
        {requiredStar}
      </FlexLayout>

      <Input
        type="text"
        name="name"
        id="name"
        value={values.name}
        onBlur={() => setFieldTouched('name', true)}
        onChange={e => setFieldValue('name', e.target.value)}
        placeholder="Model name"
        style={{ boxSizing: 'border-box' }}
      />
      {errors.name && touched.name ? (
        <Text color="errorText" fontSize="xs">
          {errors.name}
        </Text>
      ) : null}

      <FlexLayout mt="sm">
        <H4 fontWeight="bold" mb="xs">
          Mapping description
        </H4>
      </FlexLayout>
      <Input
        type="text"
        name="description"
        id="description"
        value={values.description}
        onBlur={() => setFieldTouched('description', true)}
        onChange={e => setFieldValue('description', e.target.value)}
        placeholder="Model description"
        style={{ boxSizing: 'border-box' }}
      />
      {errors.description && touched.description ? (
        <Text color="errorText" fontSize="xs">
          {errors.description}
        </Text>
      ) : null}
    </Box>
  );
};

export default EditMappingFormFields;
